import { render, staticRenderFns } from "./miniTradeResults.vue?vue&type=template&id=24d34543&"
import script from "./miniTradeResults.vue?vue&type=script&lang=js&"
export * from "./miniTradeResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports